import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const GraficaFrecuencia = ({ conteo }) => {
  const data = {
    labels: ['Bajo (≤ 45.3)', 'Rango (45.4–45.7)', 'Alto (≥ 45.8)'],
    datasets: [
      {
        label: 'Frecuencia de pesos',
        data: [conteo.Bajo, conteo.Rango, conteo.Alto],
        backgroundColor: ['#ffcccc', '#ccf5cc', '#ffe0b3'],
        borderColor: ['#ff9999', '#99e699', '#ffcc80'],
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: context => `Cantidad: ${context.raw}`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Cantidad' }
      },
      x: {
        title: { display: true, text: 'Clasificación de peso' }
      }
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: '2rem auto' }}>
      <h4 style={{ textAlign: 'center', marginBottom: '1rem' }}>Distribución de Frecuencia</h4>
      <Bar data={data} options={options} />
    </div>
  );
};

export default GraficaFrecuencia;